var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuManage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8193_3215",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8193_3215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.65 13.0002L11 7.3502L16.65 1.7002L22.3 7.3502L16.65 13.0002ZM3 11.0002V3.0002H11V11.0002H3ZM13 21.0002V13.0002H21V21.0002H13ZM3 21.0002V13.0002H11V21.0002H3ZM5 9.0002H9V5.0002H5V9.0002ZM16.675 10.2002L19.5 7.3752L16.675 4.5502L13.85 7.3752L16.675 10.2002ZM15 19.0002H19V15.0002H15V19.0002ZM5 19.0002H9V15.0002H5V19.0002Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuManage);
export default __webpack_public_path__ + "static/media/menu_manage.9f734d7da1f28f7b440c3b45f19f23fc.svg";
export { ForwardRef as ReactComponent };